import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  header: {
    [LanguagesEnum.English]: 'Change of Identification',
    [LanguagesEnum.Greek]: 'Change of Identification',
  },
  subtitle: {
    [LanguagesEnum.English]:
      'If you already used this scheme in another EU country and you have closed or will close your fixed establishment in that country, and you want to continue to use the scheme by registering with us, please indicate the VAT Identification Number that you registered with in the other EU country. Please note that in order for us to accept your application, you must deregister with the other EU country before the end of the tenth day following the end of this month.',
    [LanguagesEnum.Greek]:
      'If you already used this scheme in another EU country and you have closed or will close your fixed establishment in that country, and you want to continue to use the scheme by registering with us, please indicate the VAT Identification Number that you registered with in the other EU country. Please note that in order for us to accept your application, you must deregister with the other EU country before the end of the tenth day following the end of this month.',
  },
  country_label: {
    [LanguagesEnum.English]: 'Country',
    [LanguagesEnum.Greek]: 'Χώρα',
  },
  vat_number_label: {
    [LanguagesEnum.English]: 'VAT Number',
    [LanguagesEnum.Greek]: 'Αριθμός ΦΠΑ',
  },
};

export const CanModify = {
  [SchemeTypes.EU]: (is_agent?: boolean): string[] => {
    return ['changeIdentification_country', 'changeIdentification_vatNum'];
  },
  [SchemeTypes.NON_EU]: (is_agent?: boolean): string[] => {
    return [];
  },
  [SchemeTypes.IOSS]: (is_agent: boolean): string[] => {
    if (is_agent) {
      return ['changeIdentification_country', 'changeIdentification_vatNum'];
    } else {
      return [];
    }
  },
};

export default CONFIGURATION;
